<template>
  <div class="order-details h-100">
    <app-title title="OrderDetails"/>

    <div class="row">
      <div class="col-md-3 p-md-3">
        <img class="header-logo" src="/images/logo.svg">
      </div>
      <div class="col-md-7 content-middle dashboard-row p-md-3 mt-md-3">
        <router-link class="link" to="/dashboard">
          <font-awesome-icon class="font-awesome-icon" icon="arrow-circle-left"/>
          Dashboard
        </router-link>
      </div>
      <div class="col-md-3 sidebar sidebar-right sidebar-account p-md-3">
        <app-account/>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3 d-none d-sm-block"></div>
      <div class="col-md-7 content-middle main">
        <template v-if="!loadingOrderDetails">
          <app-reference/>
        </template>
      </div>
      <div class="col-md-3 d-none d-sm-block sidebar sidebar-right"></div>
    </div>

    <div class="row lastrow">
      <div class="col-md-3 p-md-3 d-none d-sm-block"></div>
      <div class="col-md-7 content-middle p-md-3">
        <template v-if="loadingOrderDetails">
          <font-awesome-icon class="font-awesome-icon" icon="spinner" spin/>
        </template>
        <template v-else>
          <app-order-details :order="order"/>

          <app-materials/>
        </template>
      </div>
      <div class="col-md-3 sidebar sidebar-right p-md-3">
        <template v-if="loadingOrderDetails">
          <font-awesome-icon class="font-awesome-icon" icon="spinner" spin/>
        </template>
        <template v-else>
          <div class="row">
            <div class="col-sm-7">
              <div class="sub-title">
                Bestelling
              </div>
            </div>
          </div>

          <app-overview-panels/>

          <app-restmaterials/>

          <app-delivery-date-details/>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  // Order (middle)
  import Reference from '@/components/OrderDetails/Reference.vue'
  import OrderDetails from '@/components/OrderDetails/OrderDetails.vue'
  import Materials from '@/components/OrderDetails/Materials.vue'
  // Overview (right side)
  import RestMaterials from '@/components/OrderDetails/RestMaterials.vue'
  import DeliveryDateDetails from '@/components/OrderDetails/DeliveryDateDetails.vue'
  import OverviewPanels from '@/components/OrderDetails/OverviewPanels.vue'
  import Account from '@/components/Account/Account.vue'

  import { FETCH_SIDES, FETCH_ORDER_DETAILS } from '../store/types'

  export default {
    name: 'order-details',
    props: ['order'],
    data() {
      return {}
    },
    components: {
      'app-account': Account,
      'app-reference': Reference,
      'app-order-details': OrderDetails,
      'app-materials': Materials,
      'app-restmaterials': RestMaterials,
      'app-delivery-date-details': DeliveryDateDetails,
      'app-overview-panels': OverviewPanels
    },
    computed: {
      loadingOrderDetails() {
        return this.$store.getters.loadingOrderDetails
      }
    },
    created() {
      // DEBUG, load order from localstorage? We need to talk about life cycle of cart
      this.$store.dispatch(FETCH_SIDES)
      this.$store.dispatch(FETCH_ORDER_DETAILS, this.order)
    }
  }
</script>

<style lang="scss" scoped>

</style>
